import { StateProvider } from '@uirouter/angularjs';
import { Helpers } from '../helpers';

export function statesLazyRoutesConfig( $stateProvider: StateProvider ) {
  // $stateProvider
  //   .state('payment-process.**', {
  //     url: '/payment-process',
  //     lazyLoad: async ( transition ) => {
  //       Helpers.setTransitionBarState(transition, true);
  //       const { PaymentProcessModule } = await import('./payment-process/payment-process.module');
  //       Helpers.setTransitionBarState(transition, false);
  //       return Helpers.oclazyloadFromTransition(transition).inject(PaymentProcessModule.name);
  //     }
  //   });
}

statesLazyRoutesConfig.$inject = [ '$stateProvider' ];



// WEBPACK FOOTER //
// ./app/states_mobile/states-lazy-routing.ts